/**
 * @file RiskAssesment.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React, { useState } from "react";
import SkinPage from "../../SkinPage";
import Widget from "../../widgets/Widget";
import Request from "../../../../utils/fetchUtils";
import DgModal from "../../../../components/DgModal";
import Swal from "sweetalert2";
import Loader from "../../widgets/Loader";

function RiskAssessment() {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formUrl, setFormUrl] = useState();
  const getFormUrl = async () => {
    setIsLoading(true);
    const res = await Request("/trading/risk/customer");
    setIsLoading(false);
    if (res.ok) {
      setFormUrl(res.data.url);
      setIsModalOpen(true);
    }
  };
  const handleCloseModal = async () => {
    Swal.fire({
      title: "Are you done with your risk assessment?",
      text: "If test is not complete, results won't be stored in our system",
      icon: "question",
      showCancelButton: true,
    }).then(async ({ isConfirmed }) => {
      if (isConfirmed) {
        Swal.fire(
          "Results sent",
          "You will be able to see them shortly",
          "success"
        );
        //const res = await Request("/trading/risk/customer/store");
        // if (res.ok) {
        //   localStorage.setItem("score", res.data.score);
        // }
        setIsModalOpen(false);
      }
    });
  };
  return (
    <SkinPage>
      <Widget name={"broker-connection"}>
        <div className="heading">
          <h1 className="title">Risk Assessment</h1>
        </div>
        <div style={{ textAlign: "right", margin: "10px 0" }}>
          <div onClick={getFormUrl} className="btn outline-btn">
            Get my score
          </div>
        </div>
        <div></div>
      </Widget>
      <DgModal modalState={isModalOpen} handleModalState={handleCloseModal}>
        <br />
        <br />
        {formUrl && (
          <iframe
            style={{ width: "100%", height: "75vh", border: "none" }}
            src={formUrl}
          />
        )}
      </DgModal>
      {isLoading ? <Loader /> : null}
    </SkinPage>
  );
}

export default RiskAssessment;
